import http from "./http-client";

class AuthService {
  login(payload) {
    return http.post("/Login", payload);
  }
}

export default new AuthService();
